<template>
  <div>
    <el-dialog
            title="提示"
            :visible.sync="newbieTaskDialog"
            width="400px"
            :before-close="refresh">
      <div class="code">
        <qriously :value="task_url" :size="200" />
        <p>微信扫一扫，分享新手任务</p>
      </div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
    <div class="box760">
      <div class="steps flex justify-content align-items">
        <div class="item active justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">填写资料</p>
        </div>
        <div class="line line-ff9203"></div>
        <div class="item active justify-content align-items flex column">
          <p class="circular"><i></i></p>
          <p class="text">达人培训</p>
        </div>
        <div class="line line-777" v-if="this.$store.state.is_auth === 0"></div>
        <div class="line line-ff9203" v-if="this.$store.state.is_auth === 1"></div>
        <div class="line line-f56c6c" v-if="this.$store.state.is_auth === 2"></div>
        <div class="item underway justify-content align-items flex column" v-if="this.$store.state.is_auth === 0">
          <p class="circular"><i></i></p>
          <p class="text">线下核实</p>
        </div>
        <div class="item active justify-content align-items flex column" v-if="this.$store.state.is_auth === 1">
          <p class="circular"><i></i></p>
          <p class="text">认证完成</p>
        </div>
        <div class="item error justify-content align-items flex column" v-if="this.$store.state.is_auth === 2">
          <p class="circular"><i></i></p>
          <p class="text">认证未通过</p>
        </div>
      </div>
    </div>
    <div class="box760 white-bg shadow fromBox border">
      <div class="result" v-if="this.$store.state.is_auth === 0">
        <div class="state">
          <p class="icon el-icon-date"></p>
          <p class="state-text">线下核实</p>
        </div>
        <div class="text">
          <p>恭喜您通过{{this.$store.state.siteName}}线上培训</p>
          <p>工作人员将会在3个工作日内进行资料审核，请您耐心等待哦</p>
        </div>
      </div>
      <!--核实-->
      <div class="result" v-if="this.$store.state.is_auth === 1">
        <div class="state">
          <p class="icon el-icon-success"></p>
          <p class="state-text">认证成功</p>
        </div>
        <div class="text">
          <p>恭喜您通过达人认证！</p>
          <p>现在可以领取新手任务，完成后即可抢单</p>
        </div>
        <div class="newbieTaskClick" v-if="this.$store.state.newbie_task === 0">新手任务需要{{clicknum}}个点击量，已经完成{{real_num}}个点击量</div>
        <div class="newbieTaskClick" v-if="this.$store.state.newbie_task === 1">恭喜您，已经成功完成了新手任务</div>
        <div class="btn flex justify-content">
          <el-button type="primary" class="btn-item" @click="newbieTask" v-if="this.$store.state.newbie_task === 0">立即去完成新手任务</el-button>
          <el-button type="primary" class="btn-item" @click="gotoList" v-if="this.$store.state.newbie_task === 1">立即去接单</el-button>
        </div>
      </div>
      <!--认证成功-->
      <div class="result" v-if="this.$store.state.is_auth === 2">
        <div class="state">
          <p class="icon el-icon-error"></p>
          <p class="state-text">认证未通过</p>
        </div>
        <div class="text">
          <p>很抱歉，您的情况与平台要求不符，未通过达人认证</p>
          <p>如有疑问请拨打{{this.$store.state.cityTel}}</p>
        </div>
      </div>
      <!--认证失败-->
    </div>
  </div>
</template>
<script>
import {newbieTask,newbieTaskUrl,myDarenInfo} from '@/config/api.js'
export default {
  name: 'DarenResult',
  inject:['reload'],
  data () {
    return {
      is_auth: this.$store.state.is_auth,
      newbieTaskDialog: false,
      clicknum: null,
      real_num: null,
      task_url:newbieTaskUrl + '?user_id=' + this.$store.state.user_id
    }
  },
  methods: {
    newbieTask () {
      this.newbieTaskDialog = true;
    },
    gotoList () {
      this.$router.push('/list')
    },
    getNewbieTask () {
      let data = {
        user_id: this.$store.state.user_id,
      };
      this.$post(newbieTask,data)
              .then(res => {
                this.clicknum = res.data.clicknum;
                this.real_num = res.data.real_num;
              })
    },
    gotoManage () {
      if (this.$store.state.newbie_task === 1) {
        this.$router.push('/daren/manage')
      }
    },
    getInfo () {
      let data = {
        user_id: this.$store.state.user_id,
        user_type: this.$store.state.user_type,
      };
      this.$post(myDarenInfo, data)
              .then(res => {
                let data = res.data;
                this.is_auth = Number(data.is_auth);
                this.newbie_task = Number(data.newbie_task);
                this.auth_type = Number(data.auth_type);
                this.$store.commit('changeAuthType',this.auth_type);
                this.$store.commit('changeIsAuth',this.is_auth);
                this.$store.commit('changeNewbieTask',this.newbie_task);
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    checkDaren () {
      if (this.$store.state.user_type !== 1) {
        this.$message.error('很抱歉，您不是达人用户，请注册认证！');
        this.$router.push('/')
      }
    },
    refresh () {
      this.newbieTaskDialog = false;
      this.reload()
    }
  },
  created() {
    this.getNewbieTask();
    // this.gotoManage();
    this.getInfo();
    this.checkDaren();
  }
}
</script>
<style scoped>
  .btn{margin-top:30px;}
  .btn .btn-item{width:180px;}
  .code{text-align: center;}
  .newbieTaskClick{margin-top: 20px;border:1px #eee dashed;height:36px;line-height: 36px;border-radius: 4px;color: #ff9203;}
</style>
